<template>
  <v-text-field
    v-mask="option.mask || null"
    class="primary--text"
    hide-details="auto"
    :label="option.name"
    outlined
    @change="updated"
    :loading="loading"
    :value="selectedOptions"
    :rules="option.rules || null"
  />
</template>

<script>
import { SET_SELECTED_OPTION, GET_EVENTS } from "../../../store/actions.type";
import { mask } from 'vue-the-mask'

export default {
  name: "Textfield",
  directives: {
    mask
  },
  props: {
    option: Object
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    selectedOptions() {
      return this.$store.getters.getCurrentSelectedOptions(this.option.key);
    }
  },
  methods: {
    updated(options) {
      let key = this.option.key;
      this.$gtag.event("api", {
        event_category: "options",
        event_label: "set_selected_option",
        value: options
      });
      this.$store
      .dispatch(SET_SELECTED_OPTION, { key, options })
      .then(() => {
        this.loading = false;
        this.$gtag.event("api", {
          event_category: "events",
          event_label: "get_events",
        });
        this.$store.dispatch(GET_EVENTS);
      });
    }
  }
};
</script>

<style scoped>
.v-text-field--outlined >>> .v-label {
  color: #0057B8;
  font-weight:bold;
}

.v-text-field--outlined >>> input {
  color: #0057B8;
}

.v-text-field--outlined >>> fieldset {
  border-color: #0057B8;
}
</style>